import { useState } from 'react';
import Tab from '../../../components/Tab/Tab';
import Accordion from '../../../components/Accordion/Accordion';
import { Button } from 'antd';
import { IMAGE_BASE_URL } from '../../../common/Constants';
import { useLocation, useNavigate } from 'react-router-dom';

const FlooringDetails = ({
  ApplicationData,
  HandleFilters,
  statusTab,
  returnState,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const CartItems = ApplicationData?.cart?.map((it) => it?.agent);
  const VehicleInfo = ApplicationData?.vehicleInfo;
  const [activeTab, setActiveTab] = useState(statusTab);
  const tabs = [
    `Issued (${CartItems?.filter((it) => it?.agent_approved_status == 1)?.length
    })`,
    `Pending (${CartItems?.filter((it) => it?.agent_approved_status == 0)?.length
    })`,
    `Rejected (${CartItems?.filter((it) => it?.agent_approved_status == 2)?.length
    })`,
  ];

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    HandleFilters({ statusTab: tabIndex });
  };
  {
    console.log('CartItems', CartItems);
  }

  return (
    <section>
      <div className='tab-section'>
        <Tab tabs={tabs} activeTab={activeTab} onTabChange={handleTabChange} />
      </div>

      <div className='tab-body-section !pt-[20px] !m-0'>
        {activeTab === 0 &&
          CartItems?.length > 0 &&
          CartItems?.filter((it) => it?.agent_approved_status == 1)?.map(
            (item) => (
              <Accordion
                title={item?.name}
                image={`${IMAGE_BASE_URL}${item?.icon}`}
              >
                <div className={`preview-list-block case-acc-${activeTab}`}>
                  <div className='preview-list-group'>
                    <div className='preview-list'>
                      <h3>Intended Floor Amount</h3>
                      <p>
                        $
                        {VehicleInfo?.intended_floor_amount.slice(
                          0,
                          VehicleInfo?.intended_floor_amount.indexOf('.')
                        )}
                      </p>{' '}
                    </div>
                    <div className='preview-list'>
                      <h3>Interest Rate (per 30 days)</h3>
                      {/* <p>
                        {item?.product?.interest_from.slice(
                          0,
                          item?.product?.interest_from.indexOf('.') + 2
                        )}{' '}
                        % -{' '}
                        {item?.product?.interest_to.slice(
                          0,
                          item?.product?.interest_to.indexOf('.') + 2
                        )}{' '}
                        %
                      </p> */}
                      <p>
                        {VehicleInfo?.floor_interest}{' '} %
                      </p>
                    </div>
                    <div className='preview-list'>
                      <h3>Admin Fee</h3>
                      {/* <p>
                        {' '}
                        $
                        {item?.product.admin_fee_from.slice(
                          0,
                          item?.product.admin_fee_from.indexOf('.')
                        )}{' '}
                        - $
                        {item?.product?.admin_fee_to.slice(
                          0,
                          item?.product?.admin_fee_to.indexOf('.')
                        )}
                      </p> */}
                      <p>
                        ${' '}{Math.round(item?.agent_admin_fee)}
                      </p>
                    </div>{' '}
                    <div className='preview-list'>
                      <h3>Status</h3>
                      {item?.dealer_approved_status === 0 && (
                        <span className='case-status-block'>Issued</span>
                      )}
                      {item?.dealer_approved_status === 1 && (
                        <span className='case-status-block'>Completed</span>
                      )}

                    </div>{' '}
                    <div className='preview-list'>
                      <h3>Actions</h3>
                      <Button
                        type='button'
                        className='sav_btn'
                        onClick={() => {
                          navigate('/flooring-cases/view/issueAAF', {
                            state: {
                              floorData: ApplicationData,
                              returnState: returnState,
                              caseState: location.state,
                            },
                          });
                        }}
                      >
                        View AAF
                      </Button>
                    </div>
                  </div>
                </div>
                {item?.agent_other_conditions !== null &&
                  item?.agent_other_conditions !== undefined && (
                    <p className='case-warning'>
                      <span>Other Conditions:</span>{' '}
                      {item?.agent_other_conditions}
                    </p>
                  )}
                {Object.keys(item?.vouchers)?.length > 0 &&
                  Object.keys(item?.vouchers) !== undefined && (
                    <div className='eligible-voucher-section'>
                      <div className='eligible-voucher-block'>
                        <div className='eligible-circle-left'></div>
                        <div className='eligible-voucher-list'>
                          <h1>Voucher Applied</h1>
                          <h2>
                            Interest Rate{' '}
                            <span>
                              {item?.vouchers?.interest_rate.slice(
                                0,
                                item?.vouchers?.interest_rate.indexOf('.') + 2
                              )}
                              %
                            </span>
                          </h2>
                          <h2>
                            Eligible Floor Amt.:
                            <span>
                              {' '}
                              $
                              {item?.vouchers.amount_from.slice(
                                0,
                                item?.vouchers.amount_from.indexOf('.')
                              )}{' '}
                              - $
                              {item?.vouchers?.amount_to.slice(
                                0,
                                item?.vouchers?.amount_to.indexOf('.')
                              )}
                            </span>
                          </h2>
                          {item?.agent_voucher_approved_status == 0 && (
                            <h3>
                              Status:{' '}
                              <span className='case-status-pending'>
                                Pending
                              </span>
                            </h3>
                          )}
                          {item?.agent_voucher_approved_status == 1 && (
                            <h3>
                              Status:{' '}
                              <span className='case-status-issued'>
                                Accepted
                              </span>
                            </h3>
                          )}
                          {item?.agent_voucher_approved_status == 2 && (
                            <h3>
                              Status:{' '}
                              <span className='case-status-rejected'>
                                Rejected
                              </span>
                            </h3>
                          )}
                        </div>
                        <div className='eligible-circle-right'></div>
                      </div>
                    </div>
                  )}
              </Accordion>
            )
          )}
        {activeTab === 1 &&
          CartItems?.length > 0 &&
          CartItems?.filter((it) => it?.agent_approved_status == 0)?.map(
            (item) => (
              <Accordion
                title={item?.name}
                image={`${IMAGE_BASE_URL}${item?.icon}`}
              >
                <div className={`preview-list-block case-acc-${activeTab}`}>
                  <div className='preview-list-group'>
                    <div className='preview-list'>
                      <h3>Intended Floor Amount</h3>
                      <p>
                        $
                        {VehicleInfo?.intended_floor_amount.slice(
                          0,
                          VehicleInfo?.intended_floor_amount.indexOf('.')
                        )}
                      </p>{' '}
                    </div>
                    <div className='preview-list'>
                      <h3>Interest Rate (per 30 days)</h3>
                      <p>
                        {item?.product?.interest_from.slice(
                          0,
                          item?.product?.interest_from.indexOf('.') + 2
                        )}{' '}
                        % -{' '}
                        {item?.product?.interest_to.slice(
                          0,
                          item?.product?.interest_to.indexOf('.') + 2
                        )}{' '}
                        %
                      </p>
                    </div>
                    <div className='preview-list'>
                      <h3>Admin Fee</h3>
                      <p>
                        {' '}
                        $
                        {item?.product.admin_fee_from.slice(
                          0,
                          item?.product.admin_fee_from.indexOf('.')
                        )}{' '}
                        - $
                        {item?.product?.admin_fee_to.slice(
                          0,
                          item?.product?.admin_fee_to.indexOf('.')
                        )}
                      </p>
                    </div>{' '}
                    <div className='preview-list'>
                      <h3>Status</h3>
                      <span className='case-status-block'>Pending</span>
                    </div>{' '}
                    {/* <div className="preview-list">
                      <h3>Actions</h3>
                       <Button
                      type="button"
                      className="sav_btn"
                      onClick={() => {
                        console.log("Issue AAF");
                      }}
                    >
                      View AAF
                    </Button>
                      N/A
                    </div> */}
                  </div>
                </div>
                {item?.agent_other_conditions !== null &&
                  item?.agent_other_conditions !== undefined && (
                    <p className='case-warning'>
                      <span>Other Conditions:</span>{' '}
                      {item?.agent_other_conditions}
                    </p>
                  )}
                {Object.keys(item?.vouchers)?.length > 0 &&
                  Object.keys(item?.vouchers) !== undefined && (
                    <div className='eligible-voucher-section'>
                      <div className='eligible-voucher-block'>
                        <div className='eligible-circle-left'></div>
                        <div className='eligible-voucher-list'>
                          <h1>Voucher Applied</h1>
                          <h2>
                            Interest Rate{' '}
                            <span>
                              {item?.vouchers?.interest_rate.slice(
                                0,
                                item?.vouchers?.interest_rate.indexOf('.') + 2
                              )}
                              %
                            </span>
                          </h2>
                          <h2>
                            Eligible Floor Amt.:
                            <span>
                              {' '}
                              $
                              {item?.vouchers.amount_from.slice(
                                0,
                                item?.vouchers.amount_from.indexOf('.')
                              )}{' '}
                              - $
                              {item?.vouchers?.amount_to.slice(
                                0,
                                item?.vouchers?.amount_to.indexOf('.')
                              )}
                            </span>
                          </h2>
                          {item?.agent_voucher_approved_status == 0 ||
                            (item?.agent_voucher_approved_status == null && (
                              <h3>
                                Status:{' '}
                                <span className='case-status-pending'>
                                  Pending
                                </span>
                              </h3>
                            ))}
                          {item?.agent_voucher_approved_status == 1 && (
                            <h3>
                              Status:{' '}
                              <span className='case-status-issued'>
                                Accepted
                              </span>
                            </h3>
                          )}
                          {item?.agent_voucher_approved_status == 2 && (
                            <h3>
                              Status:{' '}
                              <span className='case-status-rejected'>
                                Rejected
                              </span>
                            </h3>
                          )}
                        </div>
                        <div className='eligible-circle-right'></div>
                      </div>
                    </div>
                  )}
              </Accordion>
            )
          )}
        {activeTab === 2 &&
          CartItems?.length > 0 &&
          CartItems?.filter((it) => it?.agent_approved_status == 2)?.map(
            (item) => (
              <Accordion
                title={item?.name}
                image={`${IMAGE_BASE_URL}${item?.icon}`}
              >
                <div className={`preview-list-block case-acc-${activeTab}`}>
                  <div className='preview-list-group'>
                    <div className='preview-list'>
                      <h3>Intended Floor Amount</h3>
                      <p>
                        $
                        {VehicleInfo?.intended_floor_amount.slice(
                          0,
                          VehicleInfo?.intended_floor_amount.indexOf('.')
                        )}
                      </p>
                    </div>
                    <div className='preview-list'>
                      <h3>Interest Rate (per 30 days)</h3>
                      <p>
                        {item?.product?.interest_from.slice(
                          0,
                          item?.product?.interest_from.indexOf('.') + 2
                        )}{' '}
                        % -{' '}
                        {item?.product?.interest_to.slice(
                          0,
                          item?.product?.interest_to.indexOf('.') + 2
                        )}{' '}
                        %
                      </p>
                    </div>
                    <div className='preview-list'>
                      <h3>Admin Fee</h3>
                      <p>
                        {' '}
                        $
                        {item?.product.admin_fee_from.slice(
                          0,
                          item?.product.admin_fee_from.indexOf('.')
                        )}{' '}
                        - $
                        {item?.product?.admin_fee_to.slice(
                          0,
                          item?.product?.admin_fee_to.indexOf('.')
                        )}
                      </p>
                    </div>{' '}
                    <div className='preview-list'>
                      <h3>Status</h3>
                      <span className='case-status-block'>Rejected</span>
                    </div>{' '}
                    {/* <div className="preview-list">
                      <h3>Actions</h3>
                      <Button
                      type="button"
                      className="sav_btn"
                      onClick={() => {
                        console.log("Issue AAF");
                      }}
                    >
                      View AAF
                    </Button>
                      N/A
                    </div> */}
                  </div>
                </div>
                {item?.agent_other_conditions !== null &&
                  item?.agent_other_conditions !== undefined && (
                    <p className='case-warning'>
                      <span>Other Conditions:</span>{' '}
                      {item?.agent_other_conditions}
                    </p>
                  )}
                {Object.keys(item?.vouchers)?.length > 0 &&
                  Object.keys(item?.vouchers) !== undefined && (
                    <div className='eligible-voucher-section'>
                      <div className='eligible-voucher-block'>
                        <div className='eligible-circle-left'></div>
                        <div className='eligible-voucher-list'>
                          <h1>Voucher Applied</h1>
                          <h2>
                            Interest Rate{' '}
                            <span>
                              {item?.vouchers?.interest_rate.slice(
                                0,
                                item?.vouchers?.interest_rate.indexOf('.') + 2
                              )}
                              %
                            </span>
                          </h2>
                          <h2>
                            Eligible Floor Amt.:
                            <span>
                              {' '}
                              $
                              {item?.vouchers.amount_from.slice(
                                0,
                                item?.vouchers.amount_from.indexOf('.')
                              )}{' '}
                              - $
                              {item?.vouchers?.amount_to.slice(
                                0,
                                item?.vouchers?.amount_to.indexOf('.')
                              )}
                            </span>
                          </h2>
                          <h3>
                            Status:{' '}
                            <span className='case-status-rejected'>
                              Rejected
                            </span>{' '}
                          </h3>
                        </div>
                        <div className='eligible-circle-right'></div>
                      </div>
                    </div>
                  )}
              </Accordion>
            )
          )}
      </div>
    </section>
  );
};

export default FlooringDetails;
